import React from "react";
import { useLocation } from 'react-router-dom';
import Header from '../header/Header';
import Logo from '../../images/logo.png';
import Logo1 from '../../images/logo-1.png';

export default function Navbar(props) {
  const [scroll, setScroll] = React.useState(0);
  const location = useLocation();

  const handleScroll = () => setScroll(document.documentElement.scrollTop);

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const className = scroll > 80 ? "fixed-navbar active" : "fixed-navbar";
  
  // Use logo-1.png only for /home route, otherwise use the passed Logo prop or default logo
  const currentLogo = location.pathname === '/home' 
    ? Logo1 
    : (props.Logo || Logo);

  return (
    <div className={className}>
      <Header hclass={props.hclass} Logo={currentLogo} topbarClass={props.topbarClass} />
    </div>
  );
}